export default __webpack_public_path__ + "static/media/menu7.3555a8f8.png";